import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../../Asset/SAI STEELS.png";
import { FaFacebookF, FaWhatsapp, FaInstagram, FaGoogle } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { IoMdCall, IoMdMail } from "react-icons/io";
import { HiMenuAlt3, HiX } from "react-icons/hi";

function Navbar() {
  const [activeTab, setActiveTab] = useState("Home");
  const [menuOpen, setMenuOpen] = useState(false);

  const menuItems = [
    { name: "Home", path: "/" },
    { name: "About Us", path: "/about" },
    { name: "Products", path: "/products" },
    { name: "Contact Us", path: "/contact" },
  ];

  return (
    <nav className="  md:bg-gradient-to-r md:from-white md:to-[#fbb613] bg-gradient-to-r from-[#fbb613] to-white shadow-md border-b">
      <div className="max-w-screen-2xl mx-auto px-4 py-2 flex items-center justify-between">
        
        {/* Logo */}
        <div className="  justify-center items-center gap-4">
          <img src={logo} alt="SAI STEELS" className="h-[80px] w-auto ml-2  object-contain" />
          <p className="text-[#114497] text-xs">We bring steel to life</p>
        </div>

<div>
  <table>
    <tbody>
      <td className="text-gray-600 text-sm font-bold">

      </td>
    </tbody>
  </table>
</div>

        {/* Desktop Menu */}
        <ul className="hidden lg:flex gap-6 text-white font-semibold">
          {menuItems.map((item) => (
            <li key={item.name}>
              <Link
                to={item.path}
                onClick={() => setActiveTab(item.name)}
                className={`px-4 py-2  transition duration-200 ${
                  activeTab === item.name
                    ? "bg-[#114497] text-white"
                    : "hover:bg-white text-[#114497] hover:text-[#fbb613]"
                    
                }`}
              >
                {item.name}
              </Link>
            </li>
          ))}
        </ul>

        {/* Contact & Social - Desktop */}
        <div className="hidden font-medium lg:flex items-center gap-6 text-[#114497] text-sm">
          <div className="flex items-center gap-2">
            <IoMdCall /> +91 90947 93999
          </div>
          <div className="flex items-center gap-2">
            <IoMdMail /> ceo@saisteels.com
          </div>
          <div className="flex gap-3 text-lg">
  <a href="https://www.facebook.com/saisteelsindia/" target="_blank" rel="noopener noreferrer">
    <FaFacebookF className="hover:text-blue-600" />
  </a>
  <a href="https://www.google.com/search?q=Sai+Steels&stick=H4sIAAAAAAAA_-NgU1I1qDBOSkwxtjRISk4yNDRLNra0MqgwN01NMTU1T7MwTTY1Tk1NXsTKFZyYqRBckpqaUwwAl7ksdTYAAAA&hl=en&mat=CZfZv2ZtBM0DElcBmzl_pYWSN8TgeBLoM2GXS3X5F-I2sQG51oHsHNsVBkaOsKZnIUNT1vg9pwXK2jJChQ1VlcXVJ_o2TQDDKj1tb7vr87F-cgCLulIjH47aPkMZgFMCh94&authuser=0" target="_blank" rel="noopener noreferrer">
    <FaGoogle className="hover:text-pink-400" />
  </a>
  <a href="https://wa.me/+919094793999" target="_blank" rel="noopener noreferrer">
    <FaWhatsapp className="hover:text-green-600" />
  </a>
  <a href="https://www.instagram.com/saisteelsvellore/" target="_blank" rel="noopener noreferrer">
    <FaInstagram className="hover:text-pink-600" />
  </a>
</div>
  <Link to="/contact">
          <button className="bg-[#114497] text-white px-4 py-2  hover:bg-white hover:text-[#fbb613]">
            Bulk Enquiry
          </button>
          </Link>
        </div>

        {/* Mobile Menu Toggle */}
        <div className="lg:hidden">
          <button onClick={() => setMenuOpen(!menuOpen)}>
            {menuOpen ? <HiX size={28} /> : <HiMenuAlt3 size={28} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="lg:hidden px-4 pb-4 space-y-2">
          <ul className="flex flex-col gap-2 text-white font-semibold">
            {menuItems.map((item) => (
              <li key={item.name}>
                <Link
                  to={item.path}
                  onClick={() => {
                    setActiveTab(item.name);
                    setMenuOpen(false);
                  }}
                  className={`block px-4 py-2 rounded-md ${
                    activeTab === item.name
                      ? "bg-[#114497] text-white"
                      : "hover:bg-white hover:text-[#fbb613]"
                  }`}
                >
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>

          <div className="mt-4  font-semibold space-y-2 text-[#114497] text-sm">
            <div className="flex items-center gap-2">
              <IoMdCall /> +91 90947 93999
            </div>
            <div className="flex items-center gap-2">
              <IoMdMail /> saisteels99@gmail.com
            </div>
            <div className="flex gap-4 text-lg mt-2">
              <FaFacebookF />
              <FaXTwitter />
              <FaWhatsapp />
              <FaInstagram />
            </div>
            <button className="mt-3 w-full bg-[#114497] text-white py-2 hover:bg-white hover:text-[#fbb613]">
              Bulk Enquiry
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}

export default Navbar;
